import {
  SummaryChipDivider,
  SummaryInfoDisplay,
  SummarySection,
  useSetFilter,
} from "@pharmupp/p3-front-commons"
import type {
  ApiSignatoriesSummary,
  SignatoryStatus,
} from "../../Signatory/SignatoriesList/types"
import { STATUS_COLOR } from "../../commons/colors"
import { getSignatureRequestsLink } from "./TemplateCard"

export const TemplateSummaryBanner = ({
  summary,
  templateId,
}: { summary: ApiSignatoriesSummary; templateId: string }) => {
  return (
    <TemplateSummarySection
      templateId={templateId}
      chips={[
        {
          status: undefined,
          total: summary.receiversCount,
          label: "Destinataires",
          baseColor: STATUS_COLOR.ALL,
        },
        {
          status: "ERROR",
          total: summary.errorCount,
          label: "Erreur",
          baseColor: STATUS_COLOR.ERROR,
        },
        {
          divider: true,
        },
        {
          status: "UNSIGNED",
          total: summary.unsignedCount,
          label: "À signer",
          baseColor: STATUS_COLOR.UNSIGNED,
        },
      ]}
    />
  )
}

type TemplateSummaryChip = {
  status?: SignatoryStatus
  total: number
  label: string
  baseColor: string
}

const TemplateSummarySection = ({
  templateId,
  chips,
}: {
  templateId: string
  chips: (TemplateSummaryChip | { divider: true })[]
}) => {
  const setFilter = useSetFilter()

  return (
    <SummarySection>
      {chips.map((chip, index) => {
        if ("divider" in chip) {
          // biome-ignore lint/suspicious/noArrayIndexKey: divider needs unique key
          return <SummaryChipDivider key={`divider-${index}`} />
        }

        return (
          <SummaryInfoDisplay
            key={`${chip.status ?? "all"}`}
            label={chip.label}
            count={chip.total}
            baseColor={chip.baseColor}
            variant="outlined"
            onClick={
              // For the moment, there are no REFUSED documents
              chip.status === "REFUSED"
                ? undefined
                : (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                    event.stopPropagation()
                    event.preventDefault()
                    setFilter(
                      [{ filterName: "status", filterValue: chip.status }],
                      getSignatureRequestsLink(templateId),
                    )
                  }
            }
          />
        )
      })}
    </SummarySection>
  )
}
